import { render, staticRenderFns } from "./ClientUsersSettings.vue?vue&type=template&id=c60eff04&scoped=true&"
import script from "./ClientUsersSettings.vue?vue&type=script&lang=js&"
export * from "./ClientUsersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60eff04",
  null
  
)

export default component.exports